module.exports = __webpack_public_path__ + "img/pnt.90cdaee6.svg";